export default __webpack_public_path__ + "static/media/ArcTrade_Terms_of_Service.e5abac97.pdf";